//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Use Vuex
import {fetchManuscripts, chooseManuscript} from '@/api/order'
import {formatTime} from '@/utils/index'

export default {
  data () {
    return {
      orderId: '',
      taxonomy: '',
      manuscriptItems: []
    }
  },
  components: {},
  methods: {
    getMenuscript () {
      fetchManuscripts(this.taxonomy).then(resp => {
        console.log(resp, 321)
        this.manuscriptItems = resp.data.map(data => {
          const createdAt = formatTime(data.created_at)
          return {
            title: data.title,
            createdAt,
            description: data.description,
            manuscriptId: data.manuscript_id
          }
        })
      }).catch((e) => console.log('error', e))
    },
    handleChoose (manuscriptId) {
      const _this = this
      this.$vux.confirm.show({
        content: '是否选择当前稿件作为该订单的稿件',
        onConfirm () {
          // console.log(this) // 非当前 vm
          // console.log(_this) // 当前 vm
          chooseManuscript(_this.orderId, manuscriptId).then(resp => {
            console.log(resp, 123)
            _this.$router.replace(`/order/detail/${_this.orderId}`)
          }).catch((e) => console.log('error', e))
        }
      })
    }
  },
  mounted () {
    if (this.$route.query.taxonomy && this.$route.query.orderId) {
      this.orderId = this.$route.query.orderId
      this.taxonomy = this.$route.query.taxonomy
      this.getMenuscript()
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/manuscript/index.vue